import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from "@angular/router"

import { ForgotPaswordService } from '../../service/forgot-pasword.service';
import { NotificationService } from 'src/app/service/notification.service';
import { customValidation } from 'src/app/manager/customValidators';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { finalize } from 'rxjs/operators';
import { LoginService } from 'src/app/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [ForgotPaswordService]
})
export class ForgotPasswordComponent implements OnInit {
  MyForm: FormGroup;
  ResetForm: FormGroup;
  DisplayError: Boolean;
  DisableSubmit: Boolean = false;
  SwitchToReset: Boolean = false;
  ResponseHelper;
  captchaArray = [];
  gradientColor = null;
  captchaData  = '';
  CurrentYear;

  showCaptcha: any;
  uniqueKey: any;
  isCaptcha: boolean= false;
  version: number

  isCurrance = true;
  constructor(public loginservice:LoginService,private forgotpasswordservice: ForgotPaswordService, private notificationservice: NotificationService, private router: Router, private sanitizer: DomSanitizer) {
  this.version = environment.version;
  }


  ngOnInit() {
    this.CreateForm();
    this.callCaptcha();
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
    this.CurrentYear = (new Date()).getFullYear();
  }


  CreateForm() {
    this.MyForm = new FormGroup({
      username: new FormControl('', [Validators.required
      ]),
      captchaData: new FormControl('',  Validators.required),
      UniqueKey: new FormControl('', null)
    });
  }

  ForgotSubmit() {
    this.DisableSubmit = true;
    console.log('ForgotSubmit() : ', this.MyForm);
    this.MyForm.patchValue({ UniqueKey : this.uniqueKey });

    if (this.MyForm.valid) {
      this.DisplayError = false;
      this.forgotpasswordservice.ForgotPassword(this.MyForm.value).pipe(finalize(() => {
        this.DisableSubmit = false;
      })).subscribe(
        (data:any) => {
          this.ResponseHelper.GetSuccessResponse(data)
          // commented for now
          // this.CreateResetForm();
          // this.SwitchToReset = true;
          this.callCaptcha();
          this.MyForm.patchValue({ captchaData: '' })
          this.MyForm.controls.captchaData.setErrors(null);
          setTimeout(() => {
            this.router.navigate(['/login'])
          }, 1000);
        }, err => {
          this.callCaptcha();
          this.MyForm.patchValue({ captchaData: '' })
          this.MyForm.controls.captchaData.setErrors(null);
          this.ResponseHelper.GetFaliureResponse(err)
        })
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
    }
  }

  ResetPassword() {
    this.DisableSubmit = true;
    console.log('ResetPassword : ', this.ResetForm);
    if (this.ResetForm.valid) {
      this.DisplayError = false;
      this.forgotpasswordservice.ResetPassword(this.ResetForm.value).subscribe(
        data => {
          this.ResponseHelper.GetSuccessResponse(data)
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 2000);

        }, err => {
          this.ResponseHelper.GetFaliureResponse(err)
          this.DisableSubmit = false;

        })
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
    }
  }

  // Call API for Captcha
  callCaptcha(){
    this.isCaptcha = true;
    this.loginservice.loginCaptcha().subscribe((res:any)=> {
    this.isCaptcha = false;
    // this.ResponseHelper.GetSuccessResponse(res)
    let captcha = res.Data.responseCaptcha;
    this.uniqueKey = res.Data.UniqueKey;
    this.convertToImage(captcha);
    // this.captchaArray.push(this.showCaptcha)
    }, error => {
      this.ResponseHelper.GetFaliureResponse(error)
    })
  }

  convertToImage(captcha) {
    this.showCaptcha = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${captcha}`);
    console.log(this.showCaptcha, 'this.showCaptcha');
  }

}
